import PropTypes from 'prop-types';
import React from 'react';

const AleloError = '/messages/alelo-error.png';
import './MessageErrorTextLongIcon.style.scss';

export const MessageErrorTextLongIcon = (props) => {
  return (
    <div className="message-line" data-testid="message-long-error-icon">
      <div
        className="message-receive-long-error"
        id={`msg-${props.message.id}`}
        data-aut-test="message-receive-long-text"
      >
        <div className="message-div-long-error">
          <span>{props.message.text} </span>
          <img src={AleloError} alt="Ícone de erro da Alelo" />
        </div>
      </div>
    </div>
  );
};

MessageErrorTextLongIcon.propTypes = {
  message: PropTypes.object
};
